import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';

import {
  ChangePriorityDto,
  ChangePriorityStore,
  PriorityDto
} from '../../../../../stores/configuration/events-n-requests/priorities-store';
import { nameof } from '../../../../../utils/object';

interface ChangePriorityViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  changePriority?: ChangePriorityStore;
  currentPriority: PriorityDto;
}

// tslint:disable-next-line:no-empty-interface
interface ChangePriorityViewState {}

@connect(['changePriority', ChangePriorityStore])
class ChangePriorityView extends React.Component<ChangePriorityViewProps, ChangePriorityViewState> {
  private get changePriorityStore() {
    return this.props.changePriority;
  }

  constructor(props: ChangePriorityViewProps) {
    super(props);

    this.changePriorityStore.state.result = null;

    this.changePriorityStore.change({
      id: this.props.currentPriority.id,
      name: this.props.currentPriority.name
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: ChangePriorityViewProps) {
    if (this.changePriorityStore.state.result && this.changePriorityStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onChangeItem() {
    this.changePriorityStore.update();
  }

  @autobind
  private onCancelChangeItem() {
    this.changePriorityStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.changePriorityStore.change({ ...this.changePriorityStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelChangeItem} closeOnDimmerClick={false}>
        <Dimmer active={this.changePriorityStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('Edit Priority')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.changePriorityStore.state.result && !this.changePriorityStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.changePriorityStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.changePriorityStore.state.item && (
              <Form>
                <Form.Field>
                  <Form.Input
                    required
                    fluid
                    label={t('Priority')}
                    placeholder={t('Name')}
                    value={this.changePriorityStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<ChangePriorityDto>('name'), value)}
                  />
                </Form.Field>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelChangeItem}>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onChangeItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(ChangePriorityView);
